
import Vue from "vue";
import MainContent from "@/components/MainContent.vue";

export default Vue.extend({
  name: "Home",
  components: {
    MainContent,
  },
});
